import { Pipe, PipeTransform } from '@angular/core';
import { EntryType, OutlookEmail } from '@maximizer/outlook/shared/domain';

@Pipe({ name: 'outlookAvatarClasses' })
export class OutlookAvatarClassesPipe implements PipeTransform {
  transform(
    entry: OutlookEmail | null | undefined,
    userEmails?: Set<string> | null,
  ): Record<string, boolean> {
    const isCompany = entry?.abentryType === EntryType.Company;
    const email = entry?.emailAddress ?? '';
    const isUserEmail = !!email && !!userEmails?.has(email.toLowerCase());

    const isNeutral = !isUserEmail || isCompany;
    const isUserStyle = isUserEmail && !isCompany;

    return {
      'avatar-neutral-20': isNeutral,
      'avatar-border': isNeutral,
      'avatar-inserv-10': isUserStyle,
      'rounded-full': isUserStyle,
      'avatar-square': entry?.abentryType === EntryType.Individual || isCompany,
    };
  }
}
